// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dhsg1fiWr-wrapper"};